import type { FaireProductEntity } from "../../entity_types/product";

export const p_z49y2xsp3v: FaireProductEntity = {
  token: "p_z49y2xsp3v",
  type: "product",
  name: "Rosemary & Biotin Volumizing Shampoo Bar",
  brandToken: "b_dljmfs9o",
  brandName: "KITSCH",
  imageUrl: "https://cdn.faire.com/fastly/1aaa3015eea81fdeac921d11711f859cf35aca4fbbf78ac17e3b168e04dae12e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/581a1083277d3cd364c74d2102c09897ccae2868ad3248f304146ced3bdda294.jpeg",
    "https://cdn.faire.com/fastly/01337e6dba12547f563e680950b85e515b1971b494deec9c04bc1797db04b807.jpeg",
    "https://cdn.faire.com/fastly/8c381f6bcc987f7c7e5838593b36bd1c880984f8670136801b7a50fda9a75677.jpeg",
    "https://cdn.faire.com/fastly/55aeafd0952bbb1bccd7d163ec3308ebb7dc5d373bda7917489e5279021c03b9.jpeg"
  ],
  priceDollars: 9.7,
  description: "-Deeply cleanses fine & delicate strands from roots to ends to encourage hair growth\n-Infused with rosemary, biotin, and amaranth protein to help thicken strands from within\n-Formulated to help boost volume, shine, and keratin production for fuller-looking locks\n\nWhy You'll Love This\n-Antioxidant-rich peptide blend helps strengthen strands to reduce breakage & split ends for friction-free, resilient hair \n-Carefully balanced, lightweight formula gently cares for your hair without leaving behind residue \n-Free of parabens, phthalates, silicones & sulfates \n-pH balanced and safe for color-treated hair\n-Reduces single-use plastic: saves two bottles of liquid shampoo/conditioner.\n\nMade in the USA, Vegan, Cruelty Free, Leaping Bunny Certified\n4OCEAN CERTIFIED: For every shampoo or conditioner bar, 4ocean pulls the equivalent of one conditioner bottle’s worth of plastic from the world's oceans, rivers, and coastlines",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:14.514Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
